export default "__VITE_ASSET__D4v3YSlZ__"